module.exports = __webpack_public_path__ + "img/type-of-platform-arcore.310b56c1.webp";